import {FC, useState, useEffect, Fragment} from 'react'

import {Modal} from 'react-bootstrap'
import {Link, useNavigate} from 'react-router-dom'

type Props = {
  showModal: boolean
  handleShowModalAlert: any
  handleStepData: any
}

const AlertContent: React.FC<Props> = ({showModal, handleShowModalAlert, handleStepData}) => {
  const navigate = useNavigate()
  const [isShow, setIsShow] = useState<boolean>(true)

  useEffect(() => {
    setIsShow(showModal)
  }, [showModal])

  const handleClose = () => {
    setIsShow(false)
    handleShowModalAlert(false)
  }

  const handleFinish = () => {
    handleStepData({
      step: 5,
      is_selesai: 1,
    })
  }

  return (
    <Modal show={isShow} centered size='lg'>
      <div className='p-10'>
        <p className='h6 text-center'>Konfirmasi Pendaftaran</p>
        <p className='mt-10'>
          Apakah Anda yakin ingin mengirimkan proposal?
        </p>

        <button
          className='btn btn-primary btn-sm w-100 mt-10'
          style={{background: ' var(--Primary-L-500, #F95E2F)'}}
          onClick={handleFinish}
        >
          Ya, Kirim
        </button>

        <button
          className='btn btn-sm w-100 mt-3 text-primary'
          style={{border: '1px solid var(--Primary-L-500, #F95E2F)'}}
          onClick={handleClose}
        >
          Batal
        </button>
      </div>
    </Modal>
  )
}

const AlertModal: React.FC<Props> = ({showModal, handleShowModalAlert, handleStepData}) => {
  return (
    <AlertContent
      showModal={showModal}
      handleShowModalAlert={handleShowModalAlert}
      handleStepData={handleStepData}
    />
  )
}

export default AlertModal
